import usePxContext from './usePxAuthContext';
import AuthModal from '../features/Visitor/components/Authentication/StandardAuthModal';
import styles from './RequireAuthentication.module.scss';

type Props = {
  logins?: string[];
  children?: React.ReactNode;
};

export default function RequireAuthentication({ logins = [], children }: Props) {
  const { isAuthenticated } = usePxContext();

  return isAuthenticated
    ? <>{children}</>
    : <AuthModal classes={{ modal: styles.modal }} open closable={false} logins={logins} />;
}
